import { GxButton, GxIcon, GxRadio, GxSpinner } from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import React, { Dispatch, FC, SetStateAction, useCallback, useEffect, useState } from 'react';
import 'react-responsive-modal/styles.css';
import { useStoreon } from 'storeon/react';
import { toast } from 'react-toastify';
import { ICreateOrder, IRetrieveOrder } from '@/types';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import { IndicatorIcon } from '../../../../assets';
import Button from '../../../../components/Button';
import Clipboard from '../../../../components/Clipboard';
import InputNumbers from '../../../../components/InputNumbers';
import { TYPES_ACTIONS_ORDERS, TYPES_STATUS, PAYMENT_METHOD, PAYMENT_TYPE } from '../../consts';
import {
	createPayOrderOnline,
	generateArrMultiOrders,
	generateArrOrders,
	useOrder
} from '../../helpers';
import styles from './styles/index.module.scss';
import ModalOrderStock from './ModalOrderStock';
import {
	checkAutomaticStockOrder,
	checkManualStockOrder,
	checkPromoCode,
	orderPriceInfo
} from './helpers';
import { ORDERS, TYPE_USER } from '../../../../const';
import { IOrderInfo } from './interfaces';


/**
 * TODO Оттипизировать formik (FormikValues) для createOrder
 */
interface IUserPayment {
	onRequestClose: ( data?: Record<string, any> ) => void;
	data?: IRetrieveOrder | null;
	date?: string | null,
	formik: any,
	statusLoad: boolean,
	setStatusLoad: any,
	createOrder: any,
	visibleItem: number,
	setVisibleItem: any,
	isOrderLoading: boolean,
	setOrderInfo: Dispatch<SetStateAction<IOrderInfo>>
}

const ModalOrderPayment: FC<IUserPayment> = ( {	
  onRequestClose,
  data: DataOrder,
  formik,
  statusLoad,
  setVisibleItem,
  date,
  visibleItem, setStatusLoad,
  isOrderLoading,
  setOrderInfo
} ) => {
	const {
		dispatch,
		statusCreateMultiOrders,
		arrayDateTimeOrders,
		currentUser,
		typeOrder,
		applicationInfo,
		statusTransferOrder,
		isOnlinePaymentLoading
	} = useStoreon<State, Events>(
		'statusTransferOrder',
		'typeOrder',
		'statusCreateMultiOrders',
		'arrayDateTimeOrders',
		'currentUser',
		'applicationInfo',
		'isOnlinePaymentLoading'
	);
	const onClose = () => {
		onRequestClose();
    if (applicationInfo && !statusTransferOrder) {
      dispatch('applicationInfo/set', null)
    }

		if (statusTransferOrder) {
			dispatch('statusTransferOrder/set', false);
		}
	};

	const data = statusTransferOrder ? applicationInfo : DataOrder;

	const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>(false)
	const [isBill, setIsBill] = useState<boolean>(false);
	const [flagSpinner, setFlagSpinner] = useState(false);
	const toggleFlagSpinner = useCallback(() => setFlagSpinner((prev) => !prev), []);
	const {base_price, price_stock, price_paid, price_total} = orderPriceInfo(formik);

	const [paymentMethod, setPaymentMethod] = useState<any>({});

	const { createOrder } = useOrder();

	const handleClickDate = ( type: number ) => {
		if (type === TYPES_ACTIONS_ORDERS.TRANSFER) {
			dispatch('statusTransferOrder/set', true);
		} else {
			dispatch('statusCreateMultiOrders/set', true);
		}
		dispatch('applicationInfo/set', formik.values);
		onClose();
	};

	const booleanDisabledCheckDataTime = !formik.values.customer || formik.values.tariff_rate_multi === null;
	const disableRadioBtn = statusLoad || (!!data &&
		(data.status === TYPES_STATUS.CLOSE
			|| data.status === TYPES_STATUS.CANCEL
			|| data.status === TYPES_STATUS.PAY_SUCCESS
			|| data.status === TYPES_STATUS.PAY_PARTLY
			|| data.status === TYPES_STATUS.PAY_ONLINE
			|| (data.status === TYPES_STATUS.PAY_LOAD && !data.is_pay_here)
			|| data.status === TYPES_STATUS.PAY_ERROR
			|| data.pay_order.is_mass_booking));

	const payOnline = async ( flagMulti: boolean ) => {
		try {
			toggleFlagSpinner();
			let ordersInfo: any = data;

			if (!data) {
				const orders: ICreateOrder[] = flagMulti
					? generateArrMultiOrders(formik.values, arrayDateTimeOrders, typeOrder, typeOrder)
					: [generateArrOrders(formik.values, typeOrder, typeOrder, date)];

				const results = await createOrder({ orders, setStatusLoad, flagMultiOrders: false });

				// eslint-disable-next-line prefer-destructuring
				ordersInfo = results[ 0 ];
				toggleFlagSpinner();

			} else if (data && !flagMulti) {
				// Обновляем заявку при нажатии на "Выставить счет", чтобы получить обновленный "is_pay_here"
				await api.order.updateOrders(ordersInfo.id, { is_pay_here: formik.values.is_pay_here });
			}

			dispatch('isOnlinePaymentLoading/set', true)
			createPayOrderOnline([{
				order_id: !flagMulti ? ordersInfo.id : undefined,
				pay_order_id: flagMulti && ordersInfo ? ordersInfo.pay_order : undefined,
				session_timeout_secs: Math.trunc(formik.values.sessionTimeoutSecs) * 60
			}], setIsBill, formik)
				.then(() => {
					api.order.getOrder(ordersInfo.id)
            .then(( res ) => {
					  	setOrderInfo({
					  		visibleItem,
					  		info: res
					  	});
					  });
				})
				.catch((err: any) => {
					dispatch('isOnlinePaymentLoading/set', false)
					console.error(err)
				})

			dispatch('flagOrArray/clear');
		} finally {
			dispatch('orders/get');
			toggleFlagSpinner();
		}
	};

	const checkStock = async () => {
		if (formik.values.promo_code) checkPromoCode(formik, date, formik.values.promo_code, currentUser);
		if (formik.values.is_automatic_stock) checkAutomaticStockOrder(formik, date, currentUser);
		if (formik.values.manual_stock) checkManualStockOrder(formik, formik.values.manual_stock, currentUser, typeOrder);
	};

	useEffect(() => {
		if (data) {
			setIsPaymentLoading(true);
			api.payment.listPayment({
				pay_order_id: data.pay_order.id
			})
				.then(({ results }) => {
					const res = results.filter(( item ) => item.status === 2);
					if (res.length === 1) {
						PAYMENT_METHOD.filter(( item ) => {
							if (item.id === res[ 0 ].payment_method) {
								setPaymentMethod(item);
							}
							return false;
						});
					} else if (res.length > 1) {
						setPaymentMethod({ title: 'Смешанный' });
					}
					setIsPaymentLoading(false)
				}, () => {
					toast.error('Не удалось получить способ оплаты');
					setIsPaymentLoading(false)
				});
		}
	}, [data]);
  
  const paymentResult = (side: ORDERS): string => {
    const paymentWithDeposits = Boolean(data?.deposit_name);

    if (paymentWithDeposits) {
      if (side === ORDERS.PIPE) {
        return `${Number(data?.deposit_mins_paid)} мин.`
      }
      return `${Number(data?.deposit_sets_paid)}  сет(ов).`
    }

    if (side === ORDERS.PIPE) {
      return `${Number(data?.certificate_mins_paid)} мин.`
    }
    return `${Number(data?.certificate_sets_paid)} сет(ов).`
  }

	return (
		<>
			{!!data &&
        <div className={styles[ 'subheader' ]}>
          <span className={styles[ 'subheader--subtitle' ]}>Оплата</span>
        </div>
			}
			<div className={styles[ 'payment--block' ]}>
				{
					!isOrderLoading && (
						<ModalOrderStock formik={formik} statusLoad={statusLoad} data={data} date={date}/>
					)
				}
				{(arrayDateTimeOrders.length !== 0 || !statusCreateMultiOrders) &&
          <>
            <div className={styles[ 'payment--type' ]}>
              <GxRadio
                name="is-pay"
                className={styles[ 'payment--type-radio' ]}
                checked={formik.values.is_pay_here}
                onGx-change={() => formik.setFieldValue('is_pay_here', true)}
                disabled={disableRadioBtn || currentUser.user_status === TYPE_USER.VIEWER}
              >
                Оплата на месте
              </GxRadio>
              <GxRadio
                name="is-pay"
                className={styles[ 'payment--type-radio' ]}
                checked={!formik.values.is_pay_here}
                onGx-change={() => formik.setFieldValue('is_pay_here', false)}
                disabled={disableRadioBtn || currentUser.user_status === TYPE_USER.VIEWER}
              >Онлайн</GxRadio>
            </div>

						{(!statusCreateMultiOrders && (!!data && data.status !== TYPES_STATUS.PAY_SUCCESS) || !data) &&
              <>
								{formik.values.is_pay_here && formik.values.status !== 1 ?
									(
										<div className={styles[ 'group-button' ]}>
											<Button
												onClick={() => setVisibleItem(1)}
												disable={price_total === 0 || base_price === 0 || statusLoad || (!!data && data.status === TYPES_STATUS.CLOSE) || currentUser.user_status === TYPE_USER.VIEWER}
												className={styles[ 'payment--btn' ]} theme="btn--outline_blue"
												type="button">
												Оплатить
											</Button>
											{data?.pay_order.is_mass_booking &&
                        <Button
                          onClick={() => setVisibleItem(2)}
                          disable={price_total === 0 || base_price === 0 || statusLoad || (!!data && data.status === TYPES_STATUS.CLOSE) || currentUser.user_status === TYPE_USER.VIEWER}
                          className={styles[ 'payment--btn' ]} theme="btn--outline_blue"
                          type="button">
                          Оплатить все
                        </Button>
											}
										</div>
									) : (
										(!isBill && (formik.values.payment_confirmation_link === ''))
										&& (
											<div>
												{
													formik.values.status !== 1 && (
														<div className={styles[ 'expired-block' ]}>
															<div className={styles[ 'expired-block--title' ]}>
																Действие ссылки:
															</div>
															<div className={styles[ 'expired-block--minutes-wrap' ]}>
																<InputNumbers
																	className={styles[ 'expired-block--inp' ]}
																	value={formik.values.sessionTimeoutSecs}
																	disabled={(!!data && data.status === TYPES_STATUS.CLOSE) || currentUser.user_status === TYPE_USER.VIEWER}
																	handleInput={( e: Record<string, any> ) => formik.setFieldValue('sessionTimeoutSecs', e.target.value)}
																/>
															</div>
															<div className={styles[ 'expired-block--minutes' ]}>
																мин
															</div>
														</div>
													)
												}

												{
													formik.values.status !== 1 && (
														<div className={styles[ 'group-button' ]} style={{ gap: 50 }}>
															{
																flagSpinner ? <GxSpinner style={{ fontSize: '2rem' }}/> :
																	<Button
																		onClick={() => payOnline(statusCreateMultiOrders)}
																		className={styles[ 'payment--btn' ]}
																		disable={flagSpinner || (!!data && data.status === TYPES_STATUS.CLOSE) || currentUser.user_status === TYPE_USER.VIEWER}
																		theme="btn--outline_blue" type="button"
																	>
																		Выставить счет
																	</Button>
															}
															{
																(data?.pay_order.is_mass_booking && formik.values.payment_confirmation_link === '') &&
                                <GxSpinner style={{ fontSize: '2rem' }}/> &&
                                <Button
                                  onClick={() => payOnline(true)}
                                  className={styles[ 'payment--btn' ]}
                                  disable={flagSpinner || (!!data && data.status === TYPES_STATUS.CLOSE) || currentUser.user_status === TYPE_USER.VIEWER}
                                  theme="btn--outline_blue" type="button"
                                >
                                  Выставить счет всем
                                </Button>
															}
														</div>
													)
												}
											</div>
										)
									)}
              </>
						}
						{(!formik.values.is_pay_here && (isBill || formik.values.payment_confirmation_link !== '')) &&
              <div className={styles[ 'bill-block' ]}>
                <div className={styles[ 'bill-block--clipboard' ]}>
                  <Clipboard value={formik.values.payment_confirmation_link}/>
                </div>
              </div>
						}
          </>
				}
				<div className={styles[ 'pay-info' ]}>
					{isPaymentLoading ? (
						<div>
							<GxSpinner/>
						</div>
					) : (
						<>
							{paymentMethod.title &&
                <div className={styles[ 'total' ]}>
                  <div className={styles[ 'total--item' ]}>
                <span className={styles[ 'discount-status--label' ]}>
									Способ оплаты:
								</span>
                    <span className={styles[ 'discount-status--label' ]}>
									{paymentMethod.title}
								</span>
                  </div>
									{!!data && (data.deposit_name || data.certificate_name) &&
                    <span>
									{`${data.deposit_name ? 'Депозит: ' : 'Cертификат: '} "${data.deposit_name ? data.deposit_name : data.certificate_name}"`}
								</span>
									}
                </div>
							}
							<div className={styles[ 'total' ]}>
								{(paymentMethod.id !== PAYMENT_TYPE.FROM_DEPOSIT_MINUTES &&
										paymentMethod.id !== PAYMENT_TYPE.CERTIFICATE) &&
									!(data?.deposit_name || data?.certificate_name) && (
										<>
											<div className={styles[ 'total--item' ]}>
									<span className={styles[ 'discount-status--label' ]}>
											{statusCreateMultiOrders ? 'Общая сумма заказа:' : 'Сумма заказа:'}
									</span>
												{(currentUser.user_status !== TYPE_USER.VIEWER  && !statusCreateMultiOrders &&
													(!data || data?.status === TYPES_STATUS.PAY_LOCAL)) ? (
													<label htmlFor="promo_code" className={styles[ 'promocode--group' ]}>
														<InputNumbers
															clearable={!data}
															className={styles[ 'promocode--input' ]}
															value={String(base_price)}
															style={{ width: 150 }}
															onGx-change={( e: Record<string, any> ) => {
																formik.setFieldValue('base_price', e.target.value);
																formik.setFieldValue('price_stock', 0);
															}}
															onGx-clear={() => {
																formik.setFieldValue('base_price', 0);
															}}
														/>
														<GxButton
															className={styles[ 'promocode--btn' ]}
															onClick={checkStock}
														>
															<GxIcon className={styles[ 'promocode--btn-icon' ]}
																			src={IndicatorIcon}/>
														</GxButton>
													</label>
												) : (
													<span className={styles[ 'total--price' ]}>
											{base_price.toLocaleString()}
										</span>
												)}
											</div>

											<div
												className={cn(styles[ 'total--item' ], styles[ 'total--item_discount' ])}>
												<span>{statusCreateMultiOrders ? 'Общая скидка:' : 'Скидка:'}</span>
												<span
													className={styles[ 'total--price' ]}>{price_stock.toLocaleString()}</span>
											</div>
											{formik.values.stock_name &&
                        <div
                          className={cn(styles[ 'total--item' ], styles[ 'total--item_discount' ])}>
                    <span
                      className={cn(styles[ 'total--item' ], styles[ 'total--item_discount' ])}>Акция: {`"${formik.values.stock_name}"`}</span>
													{/* <span>{`"${formik.values.stock_name}"`}</span> */}
                        </div>
											}
											<div className={cn(styles[ 'total--item' ], styles[ 'total--item_all' ])}>
												<span>К оплате:</span>
												<span className={styles[ 'total--price' ]}>
										{price_total.toLocaleString()}
									</span>
											</div>
										</>
									)}
							</div>
						</>
					)}
				</div>
				{!statusCreateMultiOrders &&
          <div className={styles[ 'total' ]}>
            <div className={cn(styles[ 'total--item' ], styles[ 'total--item_paid' ])}>
              <span> Оплачено:</span>
							{!!data && (data.deposit_name || data.certificate_name) ? (
								<span>
									{paymentResult(data.side)}
								</span>
							) : (
								<span className={styles[ 'total--price' ]}>
									{price_paid.toLocaleString()}
								</span>
							)}
            </div>
          </div>
				}
				<div className={styles[ 'modal--btns' ]}>
					{!statusCreateMultiOrders &&
            <GxButton className={styles[ 'btn--gray' ]} onClick={onClose} disabled={statusLoad}>
              Отмена
            </GxButton>
					}
					{statusCreateMultiOrders && arrayDateTimeOrders.length === 0 ? (
						<GxButton
							className={styles[ 'btn--default' ]}
							onClick={() => handleClickDate(TYPES_ACTIONS_ORDERS.CHECK_DATE)}
							disabled={booleanDisabledCheckDataTime || currentUser.user_status === TYPE_USER.VIEWER}
						>
							Выбрать дату
						</GxButton>
					) : (
						<>
							{
								statusLoad || isOnlinePaymentLoading ? (
									<GxSpinner style={{ fontSize: '2rem' }}/>
								) : (
									<GxButton
										type="submit"
										className={styles[ 'btn--default' ]}
										disabled={
											(!formik.values.tariff.value && !statusCreateMultiOrders) ||
											currentUser.user_status === TYPE_USER.VIEWER
										}
									>
										Сохранить
									</GxButton>
								)}
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default ModalOrderPayment;
